<script>
    import {Bar} from 'vue-chartjs'
    import http from "@state/http";
    import store from "../../../../state/store";

    export default {
        extends: Bar,
        data() {
            return {
                ageDataArray: null
            };
        },
        mounted() {
            if (store.getters['auth/loggedIn']) {
                this.ageChart()
            }
        },
        methods: {
            async ageChart(){
                let tradeId= this.$route.params.trade_id;

                if (tradeId){
                    await http.get("api/ageChart/" + tradeId)
                        .then(response => {
                            this.ageDataArray = response.data.ageDataArray;
                            this.renderChart(
                                {
                                    labels: this.ageDataArray.desc,
                                    datasets: [
                                        {
                                            label: 'Trainee',
                                            backgroundColor: '#1abc9c',
                                            borderColor: '#1abc9c',
                                            hoverBackgroundColor: '#1abc9c',
                                            hoverBorderColor: '#1abc9c',
                                            data: this.ageDataArray.ageCountArray,
                                        },
                                    ],
                                },
                                {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: true,
                                    },
                                    scales: {
                                        yAxes: [
                                            {
                                                gridLines: {
                                                    display: false,
                                                },
                                                stacked: false,
                                                ticks: {
                                                    // stepSize: 1,
                                                    min: 0,
                                                    max: this.ageDataArray.max, // The response got from the ajax request containing max limit for y axis
                                                    maxTicksLimit: 5
                                                },
                                            },
                                        ],
                                        xAxes: [
                                            {
                                                barPercentage: 0.7,
                                                categoryPercentage: 0.5,
                                                stacked: false,
                                                gridLines: {
                                                    color: 'rgba(0,0,0,0.01)',
                                                },
                                            },
                                        ],
                                    },
                                }
                            )
                        })
                }else{
                    await http.get("api/ageChart")
                        .then(response => {
                            this.ageDataArray = response.data.ageDataArray;
                            this.renderChart(
                                {
                                    labels: this.ageDataArray.desc,
                                    datasets: [
                                        {
                                            label: 'Trainee',
                                            backgroundColor: '#1abc9c',
                                            borderColor: '#1abc9c',
                                            hoverBackgroundColor: '#1abc9c',
                                            hoverBorderColor: '#1abc9c',
                                            data: this.ageDataArray.ageCountArray,
                                        },
                                    ],
                                },
                                {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: true,
                                    },
                                    scales: {
                                        yAxes: [
                                            {
                                                gridLines: {
                                                    display: false,
                                                },
                                                stacked: false,
                                                ticks: {
                                                    // stepSize: 1,
                                                    min: 0,
                                                    max: this.ageDataArray.max, // The response got from the ajax request containing max limit for y axis
                                                    maxTicksLimit: 5
                                                },
                                            },
                                        ],
                                        xAxes: [
                                            {
                                                barPercentage: 0.7,
                                                categoryPercentage: 0.5,
                                                stacked: false,
                                                gridLines: {
                                                    color: 'rgba(0,0,0,0.01)',
                                                },
                                            },
                                        ],
                                    },
                                }
                            )
                        })
                }

            }
        }
    }
</script>